import React, { memo } from "react";
import { Image, Flex, Text, Spacer, Stack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import SupportCardComponent from "../card";
import { DivBox } from "./style";
export default memo(function SupportItemComponent({ item }) {
   return (
      <Flex
         as={motion.div}
         whileHover={{ y: "-10px" }}
         pt={{ base: "12px", BREAK_LPC: "18px" }}
         pb={"30px"}
         flex={1}
         flexDir={"column"}
         bg={"white"}
         boxShadow={"0px 20px 60px 0px rgba(0,0,0,0.04)"}
         borderRadius={"12px"}>
         {item.infolist.map((item) => {
            return (
               <Flex mt={"20px"} key={item}
                  px={{ base: "4vw", BREAK_LPC: "24px" }}>
                  <Image
                     alt=""
                     userSelect="none"
                     boxSize={'26px'}
                     p={"5px"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_selected.svg"}
                  />
                  <Text
                     ml={{base:'10px'}}
                     color='#333'
                     fontSize={{ base: "16px", BREAK_LPC: "20px" }}
                     lineHeight={{ base: "20px", BREAK_LPC: "28px" }}>
                     {item}
                  </Text>
               </Flex>
            );
         })}
         <Spacer />
         <DivBox>
            <Stack spacing={{ base: '5.12vw', BREAK_PAD: '20px' }}
               direction={{ base: 'row', BREAK_LPC: 'column' }}
               alignItems={'center'}
               px={{base:'5.12vw',BREAK_PAD:'20px'}}
               w={{ BREAK_PAD: '100%' }}
               overflowX={'auto'} overflowY={'hidden'}
               className={'hidscrollbar'}  >
               <SupportCardComponent item={item.bots[0]} />
               <SupportCardComponent item={item.bots[1]} />
            </Stack>
         </DivBox>

      </Flex>
   );
});
